import { render, staticRenderFns } from "./StudentMessages.vue?vue&type=template&id=384b7df8"
import script from "./StudentMessages.vue?vue&type=script&lang=js"
export * from "./StudentMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports